<p-toast position="top-right" [baseZIndex]="20000" [autoZIndex]="true"></p-toast>
<rs-about-dialog />
<rs-general-dialog
  [(visible)]="displayMessageDialog"
  [dialogTitle]="displayMessageHeader"
  i18n-confirmText
  confirmText="Ok"
  (confirmAction)="closeMessageDialog()"
  (exitAction)="closeMessageDialog()"
>
  <rs-icon headerIcon [icon]="ICONS.warningTriangle"></rs-icon>
  @if (displayMessageLines.length > 1) {
    <ul class="m-0 rs-dialog-message-list">
      @for (line of displayMessageLines; track $index) {
        <li>{{ line }}</li>
      }
    </ul>
  } @else {
    <p class="m-0">{{ displayMessageContent }}</p>
  }
</rs-general-dialog>
<rs-http-error-dialog></rs-http-error-dialog>
<rs-session-timeout-dialog [isActiveSession]="isActiveSession"></rs-session-timeout-dialog>
<rs-esim-lookup />
<div *ngIf="windowBlocked" class="block-ui" style="z-index: 40000"></div>
<div *ngIf="spinnerVisible && spinnerType === 'default'" class="centered" style="z-index: 50000">
  <div class="loadingio-spinner-dual-ring-btzitq9zwhu">
    <div class="ldio-123f4gzocnc">
      <div></div>
      <div><div></div></div>
    </div>
  </div>
</div>
<ng-container *ngIf="isActiveSession; else inactiveSessionTemplate">
  <rs-header-component />
  <div class="main-container">
    <router-outlet></router-outlet>
  </div>
</ng-container>
<ng-template #inactiveSessionTemplate>
  <router-outlet></router-outlet>
</ng-template>
